import BackofficeInterceptor from '../BackofficeInterceptor'

const api = new BackofficeInterceptor()

export default {
  getRecebimentos(medicoId: string) {
    return api.get(`/conciliacao/recebimentos/${medicoId}`)
  },
}
